import { transformSoulFromServer } from '~~/composables/useSoulApi';
import { useAuthStore } from '~~/store/auth';

function _getAuthHeaders() {
  const store = useAuthStore();
  return {
    Authorization: `Bearer ${store.user.api_token}`
  }
}

function _getApiUrl() {
  const runtimeConfig = useRuntimeConfig();
  return runtimeConfig.public.api.endpoint;
}

function _transformProjectFromServer(project) {
  if (project && Array.isArray(project.contacts)) {
    project.contacts = project.contacts.map(contact => transformSoulFromServer(contact))
  }
  return project;
}

function _transformProjectForServer(project) {
  const data = {...project};
  data.client_id = data.client ? data.client.id : null;
  data.contacts = Array.isArray(data.contacts) ? data.contacts.map(contact => contact.id): null;
  data.locations = Array.isArray(data.contacts) ? data.locations.map(location => location.id): null;
  return data;
}


export async function getProjects() {
  const { data } = await useFetch(() => `${_getApiUrl()}/events`, { 
    headers: _getAuthHeaders()
  });
  data.value = Array.isArray(data.value) 
    ? data.value.map(item => _transformProjectFromServer(item)) 
    : data.value;

  return data;
}

export async function getProjectsArchived(page = 1) {
  const { data } = await useFetch(() => `${_getApiUrl()}/events/archived/${page}`, { 
    headers: _getAuthHeaders()
  });
  data.value = Array.isArray(data.value) 
    ? data.value.map(item => _transformProjectFromServer(item)) 
    : data.value;
  return data;
}

export async function getProject(id) {
  const { data } = await useFetch(() => `${_getApiUrl()}/events/${id}`, { 
    headers: _getAuthHeaders()
  })
  if (data) {
    data.value = _transformProjectFromServer(data.value);
  }
  return data;
}

export async function createProject(project) {
  const { data } = await useFetch(() => `${_getApiUrl()}/events`, { 
    method: 'POST',
    headers: _getAuthHeaders(),
    body: _transformProjectForServer(project)
  });
  return data;
}

export async function updateProject(project) {
  const { data } = await useFetch(() => `${_getApiUrl()}/events/${project.id}`, { 
    method: 'PUT',
    headers: _getAuthHeaders(),
    body: _transformProjectForServer(project)
  });
  return data;
}

export async function archiveProject(project) {
  const { data } = await useFetch(() => `${_getApiUrl()}/events/archive/${project.id}`, { 
    method: 'PUT',
    headers: _getAuthHeaders(),
  });
  return data;
}

export async function unarchiveProject(project) {
  const { data } = await useFetch(() => `${_getApiUrl()}/events/unarchive/${project.id}`, { 
    method: 'PUT',
    headers: _getAuthHeaders(),
  });
  return data;
}

export async function destroyProject(id) {
  const { data } = await useFetch(() => `${_getApiUrl()}/events/${id}`, { 
    method: 'DELETE',
    headers: _getAuthHeaders(),
  });
  return data;
}
